export default __webpack_public_path__ + "static/media/black-arrow.895f569e.svg";